import { ServiceHistoryService } from 'api-new/generated';
import { useQuery } from 'react-query';

export const SERVICE_HISTORY_CDK_DETAILS_QUERY_KEY = 'ServiceHistoryCdkDetailsQuery';

export const useServiceHistoryCdkDetailsQuery = (params: { serviceHistoryId: string; branchId?: number }) =>
  useQuery(
    [SERVICE_HISTORY_CDK_DETAILS_QUERY_KEY, params.serviceHistoryId],
    () => ServiceHistoryService.getServiceHistoryCdkDetails(params.branchId!, params.serviceHistoryId),
    {
      enabled: !!params.serviceHistoryId
    }
  );
